import { useEffect, useRef, useState } from "react";

/**
 * 상단/하단 fixed 영역 높이를 계산해서
 * 본문 paddingTop / paddingBottom 에 사용할 수 있게 해주는 훅
 * 
 * deps: [isOpen] 같은 의존성 배열을 넘겨주면,
 *       그 값이 바뀔 때마다 높이를 다시 계산해 줌.
 */
export function useFixedLayout(deps = []) {
  const headerRef = useRef(null);
  const footerRef = useRef(null);

  const [headerSpace, setHeaderSpace] = useState(0);
  const [bottomSpace, setBottomSpace] = useState(0);

  useEffect(() => {
    const updateSpace = () => {
      const headerH = headerRef.current?.offsetHeight || 0;
      const footerH = footerRef.current?.offsetHeight || 0;

      setHeaderSpace(headerH);
      setBottomSpace(footerH);
    };

    updateSpace();
    window.addEventListener("resize", updateSpace);
    return () => window.removeEventListener("resize", updateSpace);
  }, [deps]);

  return {
    headerRef,
    footerRef,
    headerSpace,
    bottomSpace,
  };
}
